export var FIELD_TYPE = {
    TEXT: 'text',
    NUMBER: 'number',
    IMAGE: 'image',
    VIDEO: 'video',
};
export var IMAGES_PROPERTY = 'images';
export var MEDIA_PREFIX = 'media/';
